import { useAuth } from "../../context/AuthContext";
import { User, Mail, Phone, Building2, FileText } from "lucide-react";

export default function ClientPerfil() {
  const { user } = useAuth();
  return (
    <div data-testid="client-perfil">
      <div className="mb-8">
        <div className="text-xs uppercase tracking-[0.18em] text-[#D4AF37] font-semibold mb-2">Perfil</div>
        <h1 className="font-display text-3xl text-[#14213D] font-light">Meu Perfil</h1>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg p-8 max-w-2xl">
        <div className="flex items-center gap-5 mb-8 pb-6 border-b border-gray-100">
          <div className="w-20 h-20 rounded-full bg-[#14213D] text-[#D4AF37] flex items-center justify-center font-display text-2xl font-semibold">
            {user?.name?.split(" ").map(n => n[0]).slice(0, 2).join("")}
          </div>
          <div>
            <div className="font-display text-2xl text-[#14213D]">{user?.name}</div>
            <div className="text-sm text-gray-500">Cliente VM Corporate</div>
          </div>
        </div>

        <div className="space-y-5">
          {[
            { icon: User, label: "Nome completo", value: user?.name },
            { icon: Mail, label: "E-mail", value: user?.email },
            { icon: Phone, label: "Telefone", value: user?.phone || "—" },
            { icon: FileText, label: "CPF/CNPJ", value: user?.document || "—" },
            { icon: Building2, label: "Empresa", value: user?.company_name || "—" },
          ].map((it) => (
            <div key={it.label} className="flex items-start gap-4">
              <div className="w-9 h-9 rounded-md bg-gray-50 text-[#14213D] flex items-center justify-center flex-shrink-0">
                <it.icon size={16} />
              </div>
              <div className="flex-1">
                <div className="text-[11px] uppercase tracking-wider text-gray-500 font-semibold">{it.label}</div>
                <div className="text-sm text-[#14213D] font-medium mt-0.5">{it.value}</div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 pt-6 border-t border-gray-100 text-xs text-gray-400">
          Para atualizar seus dados, entre em contato com a recepção pelo WhatsApp ou pelo formulário de contato.
        </div>
      </div>
    </div>
  );
}
